import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

const control = (control: AbstractControl | null | undefined) => {
    return <UntypedFormControl>control;
};

const group = (control: AbstractControl<any, any> | null) => {
    return <UntypedFormGroup>control;
};

const array = (control: AbstractControl<any, any> | null) => {
    return <UntypedFormArray>control;
};

export { control, group, array };
